import { useEffect, useState } from "react";

const FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Geist:wght@300;400;500;600;700&family=Geist+Mono:wght@400;500;600&family=IBM+Plex+Sans:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500;600&family=Space+Grotesk:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500;600&family=Courier+Prime:wght@400;700&family=VT323&display=swap";

const PAIRS = [
  { id: "a", name: "A · Geist + Geist Mono", note: "Modern, sharp, Vercel / Linear grade. Recommended.", head: "Geist", body: "Geist", mono: "Geist Mono", type: "Geist Mono" },
  { id: "b", name: "B · IBM Plex Sans + IBM Plex Mono", note: "Real terminal heritage (IBM). Feels the most like Bloomberg.", head: "IBM Plex Sans", body: "IBM Plex Sans", mono: "IBM Plex Mono", type: "IBM Plex Mono" },
  { id: "c", name: "C · Space Grotesk + JetBrains Mono", note: "Popular in crypto/dev tools. More character, a bit more 'tech'.", head: "Space Grotesk", body: "Space Grotesk", mono: "JetBrains Mono", type: "JetBrains Mono" },
  { id: "d", name: "D · Geist + Courier Prime typewriter", note: "Geist for the site, a real typewriter face for briefings / quotes.", head: "Geist", body: "Geist", mono: "Geist Mono", type: "Courier Prime" },
  { id: "e", name: "E · Geist + VT323 retro CRT", note: "Geist for the site, a pixel CRT face for terminal moments only.", head: "Geist", body: "Geist", mono: "Geist Mono", type: "VT323" },
];

const LINE = "> tq.scan --markets 176 --strategies 10+ --grade A ... 3 setups found. BTC breakout watch, pulse 86/100";

const Typewriter = ({ font, size }) => {
  const [n, setN] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setN((v) => (v >= LINE.length + 25 ? 0 : v + 1)), 45);
    return () => clearInterval(t);
  }, []);
  return (
    <p style={{ fontFamily: font, fontSize: size }} className="min-h-[3.2em] leading-snug text-[#ECEBE4]">
      {LINE.slice(0, n)}
      <span className="ml-0.5 inline-block w-[0.55em] animate-pulse bg-[#BACD1C]">&nbsp;</span>
    </p>
  );
};

const ROWS = [["BTC", "81,056", "-3.19%", "Breakout watch", "86"], ["ETH", "2,367", "-5.76%", "Volume surge 4.3x", "62"], ["SOL", "102.20", "-4.98%", "Compression", "58"]];

const Specimen = ({ p }) => (
  <section data-testid={`font-pair-${p.id}`} className="border-t border-white/[0.08] py-16">
    <div className="mb-8 flex flex-wrap items-baseline justify-between gap-3">
      <h2 style={{ fontFamily: "Geist Mono" }} className="text-xs uppercase tracking-[0.25em] text-[#9DA3AE]">{p.name}</h2>
      <p style={{ fontFamily: "Geist Mono" }} className="text-xs text-[#7D8390]">{p.note}</p>
    </div>
    <h3 style={{ fontFamily: p.head, letterSpacing: "-0.035em" }} className="text-4xl font-semibold leading-[1.02] text-[#ECEBE4] sm:text-6xl">
      The institutional terminal. <span className="text-[#7D8390]">Built for retail.</span>
    </h3>
    <p style={{ fontFamily: p.body }} className="mt-6 max-w-2xl text-base leading-relaxed text-[#9DA3AE] md:text-lg">
      Trade setups, crypto order flow, a market pulse screener that spots volatility before the breakout, deep research and breaking news, in one terminal.
    </p>
    <div className="mt-10 grid gap-6 lg:grid-cols-2">
      <div className="border border-white/[0.08] bg-[#0D0E11]">
        <div style={{ fontFamily: p.mono }} className="grid grid-cols-5 border-b border-white/[0.06] px-4 py-2.5 text-[10px] uppercase tracking-[0.18em] text-[#5A6170]">
          <span>Mkt</span><span>Last</span><span>24h</span><span className="col-span-1">Signal</span><span className="text-right">Pulse</span>
        </div>
        {ROWS.map((r) => (
          <div key={r[0]} style={{ fontFamily: p.mono }} className="grid grid-cols-5 border-b border-white/[0.04] px-4 py-3 text-[13px] tabular-nums">
            <span className="text-[#ECEBE4]">{r[0]}</span><span className="text-[#ECEBE4]">{r[1]}</span><span className="text-[#FF4D5A]">{r[2]}</span><span className="truncate text-[#9DA3AE]">{r[3]}</span><span className="text-right text-[#BACD1C]">{r[4]}</span>
          </div>
        ))}
      </div>
      <div className="border border-white/[0.08] bg-[#0A0B0D] p-5">
        <p style={{ fontFamily: "Geist Mono" }} className="mb-3 text-[10px] uppercase tracking-[0.22em] text-[#5A6170]">Typewriter area</p>
        <Typewriter font={p.type} size={p.type === "VT323" ? 24 : 15} />
        <p style={{ fontFamily: p.type, fontSize: p.type === "VT323" ? 22 : 14 }} className="mt-4 border-t border-white/[0.06] pt-4 leading-relaxed text-[#9DA3AE]">
          BRIEFING 07:00 UTC: Funding reset overnight, whales added longs into the dip. Regime: Grind Down.
        </p>
      </div>
    </div>
    <div className="mt-8 flex flex-wrap gap-3">
      <span style={{ fontFamily: p.mono }} className="bg-[#BACD1C] px-6 py-3.5 text-sm uppercase tracking-[0.14em] text-black">Open free terminal</span>
      <span style={{ fontFamily: p.mono }} className="border border-white/20 px-6 py-3.5 text-sm uppercase tracking-[0.14em] text-[#ECEBE4]">See how it works</span>
    </div>
  </section>
);

export default function FontSpecimen() {
  useEffect(() => {
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = FONTS_URL;
    document.head.appendChild(l);
    return () => l.remove();
  }, []);
  return (
    <div data-testid="font-specimen-page" className="min-h-screen bg-[#08090B] px-6 py-16 md:px-16">
      <p style={{ fontFamily: "Geist Mono" }} className="text-xs uppercase tracking-[0.3em] text-[#7D8390]">TradrQuant · font samples</p>
      <h1 style={{ fontFamily: "Geist", letterSpacing: "-0.03em" }} className="mt-3 text-3xl font-semibold text-[#ECEBE4]">Pick a pairing</h1>
      {PAIRS.map((p) => <Specimen key={p.id} p={p} />)}
    </div>
  );
}
